/**
 * 制度定数（業務報告および給与計算の運用ガイドライン v7 §6 基準値・倍率一覧）
 *
 * 年度により変動する値（年間所定労働日数・1ヶ月平均所定労働時間）は
 * FiscalYearSettings として外部から与える。ここに置くのは制度上固定の値のみ。
 */
/** 1日の所定労働時間（分）。v4 以降 8.0h（所定＝法定） */
export const PRESCRIBED_DAILY_MINUTES = 480;
/** 1週の法定労働時間（分）。40h */
export const WEEKLY_LEGAL_MINUTES = 2400;
/** 月の割増加算基準（分）。法定外残業が月60hを超えた分に +0.25 倍 */
export const MONTHLY_OVERTIME_THRESHOLD_MINUTES = 3600;
/** みなし通勤時間（分）。行き・帰りそれぞれから控除する（平日のみ） */
export const DEEMED_COMMUTE_MINUTES = 60;
/** 食事手当の判定基準（分）。実働4:00以上、移動のみの日は移動4:00以上 */
export const MEAL_ALLOWANCE_THRESHOLD_MINUTES = 240;
/** 所定始業時刻（分, 8:30）。既定シフトの表示・初期値に使用 */
export const DEFAULT_WORK_START_MINUTES = 510;
/** 所定終業時刻（分, 18:00）。既定シフトの表示・初期値に使用 */
export const DEFAULT_WORK_END_MINUTES = 1080;
/** 平日の既定休憩時間（分） */
export const DEFAULT_WEEKDAY_BREAK_MINUTES = 90;
/**
 * 固定休憩時間帯（ガイドライン §6.3）。
 * 始業〜終業との重なりから「実働から控除する休憩（W列）」を自動算出する。
 * 平日のみ適用。
 */
export const FIXED_BREAK_BANDS = [
    [600, 615], // 10:00〜10:15
    [720, 780], // 12:00〜13:00
    [900, 915], // 15:00〜15:15
];
/**
 * 深夜時間帯（22:00以降、翌5:00未満）。
 * 跨日入力（25:00 等）に対応するため、同日表現で [0:00,5:00) と [22:00,29:00) の2帯で表す。
 */
export const NIGHT_BANDS = [
    [0, 300], // 0:00〜5:00
    [1320, 1740], // 22:00〜29:00（翌5:00）
];
/** 労基法第34条の休憩基準：実働6h超で45分、8h超で60分 */
export const BREAK_RULE = {
    over6hThresholdMinutes: 360,
    over6hRequiredMinutes: 45,
    over8hThresholdMinutes: 480,
    over8hRequiredMinutes: 60,
};
/** 割増倍率（ガイドライン §6.2） */
export const RATES = {
    /** 法定外残業（1日8h超・週40h超） */
    overtime: 1.25,
    /** 月60h超の加算分 */
    overtimeOver60Extra: 0.25,
    /** 深夜（22:00〜翌5:00）の加算分 */
    nightExtra: 0.25,
    /** 法定休日（日曜日）労働 */
    legalHoliday: 1.35,
    /** 所定休日（法定外休日）労働の8h以内分 */
    prescribedHoliday: 1.0,
    /**
     * 代休を取得する法定休日労働の割増分（ガイドライン §9.3）。
     * 基礎賃金（1.0倍）は代休日の賃金と相殺されるため、差額の 0.35 倍のみを支給する。
     */
    compensatoryLegalHolidayExtra: 0.35,
};
/** 時間単位年休の年間上限（時間）。年5日 × 8.0h */
export const HOURLY_LEAVE_ANNUAL_LIMIT_HOURS = 40;
/** 1日に取得できる時間単位年休の上限（時間） */
export const HOURLY_LEAVE_DAILY_LIMIT_HOURS = 8;
/** 長時間拘束の警告閾値（分）。12時間 */
export const LONG_ATTENDANCE_WARN_MINUTES = 720;
/** 計算エンジンの版。計算根拠画面・監査ログに記録する */
export const CALC_ENGINE_VERSION = 'v7';
//# sourceMappingURL=constants.js.map